import { Field, Form, Formik, ErrorMessage } from "formik";
import React, { useEffect, useState } from "react";
import { Button, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import * as Yup from "yup";
import moment from "moment";
import { useSelector, useDispatch } from "react-redux";
import {
  getAllStateByRegionId,
  getAllStatesbyRegionIdforCon,
  getDiscomByStateId,
  getDiscomByStateIdforCon,
  registartionRequest,
} from "../../../store/Registartion/actions";
import stateCityService from "../../../components/Services/stateCity.service";
import discomService from "../../../components/Services/discom.service";
import analystService from "../../../components/Services/analyst.service";
import { toast } from "react-toastify";
import { toastProperties } from "../../../commons/Toast/Toaster";

const EditPlantDetails = ({
  tab,
  companyDetails,
  handleSecDetails,
  secDetails,
  myProfileDetails,
  getMyProfileDetails,
  handleCloseEditProfileModal,
}) => {
  const dispatch = useDispatch();
  const controlAreaTypes = useSelector(
    (state) => state?.registrationReducer?.controlAreaTypes || []
  );
  const subsidyTypes = useSelector(
    (state) => state?.registrationReducer?.subsidyTypes || []
  );
  const discomTypes = useSelector(
    (state) => state?.registrationReducer?.discomTypes || []
  );
  const gridConnectivityTypes = useSelector(
    (state) => state?.registrationReducer?.gridConnectivityTypes || []
  );
  const voltageLevelTypes = useSelector(
    (state) => state?.registrationReducer?.voltageLevelTypes || []
  );
  const regionTypes = useSelector(
    (state) => state?.registrationReducer?.regionTypes || []
  );
  const allStateTypes = useSelector(
    (state) => state?.registrationReducer?.allStateTypes || []
  );
  const specificationTypes = useSelector(
    (state) => state?.registrationReducer?.specificationTypes || []
  );
  const energyTypes = useSelector(
    (state) => state?.registrationReducer?.energyTypes || []
  );
  const allPointDrawl = useSelector(
    (state) => state.registrationReducer?.allPointDrawl || []
  );
  const stateOptions = useSelector(
    (state) => state?.registrationReducer?.stateOptions || []
  );
  const discomOptions = useSelector(
    (state) => state?.registrationReducer?.discomOptions || []
  );
  const stateOptionsCon = useSelector(
    (state) => state?.registrationReducer?.stateOptionsCon || []
  );
  const discomOptionsCon = useSelector(
    (state) => state?.registrationReducer?.discomOptionsCon || []
  );
  let userDetails = JSON.parse(localStorage.getItem("UserDetails"));

  const initialValues = {
    isCommissioned:
      myProfileDetails?.companyResponse?.plant?.isCommissioned === true ? 1 : 2,
    commissionedAt: new Date(
      myProfileDetails?.companyResponse?.plant?.commissionedAt
    ),
    generationType:
      myProfileDetails?.companyResponse?.plant?.energyType?.genType,
    energyTypeId: myProfileDetails?.companyResponse?.plant?.energyType?.id,
    plantSpecId: myProfileDetails?.companyResponse?.plant?.specification?.id,
    maxInjCap: myProfileDetails?.companyResponse?.plant?.maxInjCap,
    projectId: myProfileDetails?.companyResponse?.plant?.projectId,
    installedCap: myProfileDetails?.companyResponse?.plant?.installedCap,
    isSubsidyRecvd:
      myProfileDetails?.companyResponse?.plant?.isSubsidyRecvd === true ? 1 : 2,
    subsidyType: myProfileDetails?.companyResponse?.plant?.subsidyType,
    isAbtExist: myProfileDetails?.companyResponse?.plant?.isAbtExist,
    poiId: myProfileDetails?.companyResponse?.plant?.poi?.id,
    poiLocation: myProfileDetails?.companyResponse?.plant?.poiLocation,
    regionId: myProfileDetails?.companyResponse?.plant?.regionId,
    stateUtId: myProfileDetails?.companyResponse?.plant?.stateUtId,
    isDiscomEmb: "",
    discomId: myProfileDetails?.companyResponse?.plant?.discom?.id,
    discomVoltageId: myProfileDetails?.companyResponse?.plant?.discomVoltage,
    controlAreaId: myProfileDetails?.companyResponse?.plant?.controlArea?.id,
    filteredVoltageLevels: discomTypes?.find(
      (item) => item.id == myProfileDetails?.companyResponse?.plant?.discom?.id
    )?.voltageLevels,
    //consumer Details
    maxCapDrawl: myProfileDetails?.companyResponse?.consumer?.maxCapDrawl,
    podId: myProfileDetails?.companyResponse?.consumer?.pod?.id,
    specId: myProfileDetails?.companyResponse?.consumer?.specification?.id,
    conDiscomId: myProfileDetails?.companyResponse?.consumer?.discom?.id,
    conFilteredVoltageLevels: discomTypes?.find(
      (item) =>
        item.id == myProfileDetails?.companyResponse?.consumer?.discom?.id
    )?.voltageLevels,
    conDiscomVoltageId:
      myProfileDetails?.companyResponse?.consumer?.discomVoltage,
    discomRegionId: myProfileDetails?.companyResponse?.consumer?.regionId,
    discomStateUtId: myProfileDetails?.companyResponse?.consumer?.stateUtId,
  };

  const submitData = (isValid, dirty, values) => {
    if (isValid && dirty) {
      handleSecDetails(values);
    } else if (!isValid) {
      setTimeout(() => {
        handleSecDetails("");
      }, 0);
    }
  };

  const handleStateChange = (id) => {
    getDiscomByStateId(id, dispatch);
  };

  const handleStateChangeforCon = (id) => {
    getDiscomByStateIdforCon(id, dispatch);
  };

  const numberInputOnWheelPreventChange = (e) => {
    // Prevent the input value change
    e.target.blur();
    // Prevent the page/container scrolling
    e.stopPropagation();
    // Refocus immediately, on the next tick (after the current function is done)
    setTimeout(() => {
      e.target.focus();
    }, 0);
  };
  useEffect(() => {
    if (myProfileDetails?.companyResponse?.plant?.regionId) {
      getAllStateByRegionId(
        myProfileDetails?.companyResponse?.plant?.regionId,
        dispatch
      );
      getDiscomByStateId(
        myProfileDetails?.companyResponse?.plant?.stateUtId,
        dispatch
      );
    }
    if (myProfileDetails?.companyResponse?.consumer?.regionId) {
      getAllStatesbyRegionIdforCon(
        myProfileDetails?.companyResponse?.consumer?.regionId,
        dispatch
      );
      getDiscomByStateIdforCon(
        myProfileDetails?.companyResponse?.consumer?.stateUtId,
        dispatch
      );
    }
  }, []);
  return (
    <Formik
      initialValues={secDetails || initialValues}
      enableReinitialize
      onSubmit={(values) => {
        let reqBodyConsumer = {
          id: myProfileDetails?.companyResponse?.consumer?.id,
          maxCapDrawl: +values.maxCapDrawl,
          podId: values.podId,
          specId: +values.specId,
          discomId: tab == 4 ? companyDetails?.conDiscomId : values.conDiscomId,
          discomVoltage: values.conDiscomVoltageId,
          stateUtId:
            tab == 4
              ? companyDetails?.discomStateUtId
              : +values.discomStateUtId,
          regionId:
            tab == 4 ? companyDetails?.discomRegionId : +values.discomRegionId,
          istsVoltage: values.istsDiscomVoltageId,
          stuVoltage: values.stuDiscomVoltageId,
        };
        let reqBodyPlant = {
          id: myProfileDetails?.companyResponse?.plant?.id,
          isCommissioned: values.isCommissioned === 1 ? true : false,
          commissionedAt: values.commissionedAt
            ? moment(values.commissionedAt).format("DD-MMM-YYYY")
            : values.commissionedAt,
          generationType: values.generationType,
          energyTypeId: parseInt(values.energyTypeId),
          plantSpecId: parseInt(values.plantSpecId),
          maxInjCap: parseInt(values.maxInjCap),
          projectId: values.projectId,
          installedCap: parseInt(values.installedCap),
          isSubsidyRecvd: values.isSubsidyRecvd == 1 ? true : false,
          subsidyType: values?.subsidyType,
          isAbtExist: values.isAbtExist == 1 ? true : false,
          controlAreaId: parseInt(values.controlAreaId),
          poiId: parseInt(values.poiId),
          poiLocation: values.poiLocation,
          regionId:
            tab == 4
              ? companyDetails?.discomRegionId
              : parseInt(values.regionId),
          stateUtId:
            tab == 4
              ? companyDetails?.discomStateUtId
              : parseInt(values.stateUtId),
          discomId:
            tab == 4 ? companyDetails?.conDiscomId : parseInt(values.discomId),
          discomVoltage: values.discomVoltageId,
        };
        let reqData = {
          user: {
            id: myProfileDetails?.userResponse?.id,
            userName: companyDetails?.userName,
            email: companyDetails?.email,
            password: companyDetails?.password,
            phone: String(companyDetails?.phone),
            roles:
              tab == 1
                ? ["GENERATOR"]
                : tab == 3
                ? ["GENERATOR", "CONSUMER"]
                : tab == 4
                ? ["GENERATOR", "CONSUMER", "BANKING"]
                : "",
          },
          company: {
            id: myProfileDetails?.companyResponse?.id,
            name: companyDetails?.name,
            displayName: companyDetails?.displayName,
            description: companyDetails?.description,
            discomId: tab==4 ?  companyDetails?.conDiscomId : null,
            istsVoltageLevel: companyDetails?.istsDiscomVoltageId,
            stuVoltageLevel: companyDetails?.stuDiscomVoltageId,
            // "logo": companyDetails?.logo,
            categoryId: +companyDetails?.categoryId,
            registeredAt: companyDetails?.registeredAt
              ? moment(companyDetails?.registeredAt).format("DD-MMM-YYYY")
              : companyDetails?.registeredAt,
            pan: companyDetails?.pan,
            tan: companyDetails?.tan,
            gst: companyDetails?.gst,
            bankAccounts: [
              {
                id:
                  myProfileDetails?.companyResponse?.bankAccounts.length > 0
                    ? myProfileDetails?.companyResponse?.bankAccounts[0]?.id
                    : null,
                nameAddress: companyDetails?.nameAddress,
                accNo: companyDetails?.accNo,
                ifsc: companyDetails?.ifsc,
                operationalAt: companyDetails?.operationalAt
                  ? moment(companyDetails?.operationalAt).format("DD-MMM-YYYY")
                  : companyDetails?.operationalAt,
              },
            ],
            addresses: [
              {
                id:
                  myProfileDetails?.companyResponse?.addresses.length > 0
                    ? myProfileDetails?.companyResponse?.addresses[0]?.id
                    : null,
                type: "OFFICE",
                address: companyDetails?.address,
                cityId: parseInt(companyDetails?.cityId),
                stateUtId: parseInt(companyDetails?.stateAndUtId),
                pin: companyDetails?.pin,
                tel: String(companyDetails?.tel),
                email: companyDetails?.officeEmail,
                fax: companyDetails?.fax ? String(companyDetails?.fax) : null,
                contactPersons: companyDetails?.contactPersons || [],
                mob: String(companyDetails?.mob),
              },
              {
                id:
                  myProfileDetails?.companyResponse?.addresses.length > 0
                    ? myProfileDetails?.companyResponse?.addresses[1]?.id
                    : null,
                type: "CORRESPONDENCE",
                address: companyDetails?.correspondenceAddress,
                cityId: parseInt(companyDetails?.correspondenceCity),
                stateUtId: parseInt(companyDetails?.correspondenceState),
                pin: companyDetails?.correspondencePinCode,
                tel: String(companyDetails?.correspondenceTelephone),
                email: companyDetails?.correspondenceEmail,
                fax: companyDetails?.correspondenceFaxNo
                  ? String(companyDetails?.correspondenceFaxNo)
                  : null,
                contactPersons:
                  companyDetails?.correspondenceContactPerson || [],
                mob: String(companyDetails?.correspondenceMobileNo),
              },
            ],
            creditRatingId: parseInt(companyDetails.creditRatingId),
            creditRatingYear: companyDetails.creditRatingYear
              ? moment(companyDetails?.creditRatingYear).format("MMM-YYYY")
              : companyDetails.creditRatingYear,
            creditRatingAgency: companyDetails.creditRatingAgency,
            plant: reqBodyPlant,
            ...((tab == 3 || tab == 4) && { consumer: reqBodyConsumer }),
          },
        };
        // registartionRequest(reqData, dispatch);
        const updateUserProfile = () => {
          analystService.editUserProfile(reqData).then((response) => {
            if (response?.data?.code === 200) {
              handleCloseEditProfileModal();
              getMyProfileDetails(userDetails?.userId);
              toast.success(response?.data?.message, toastProperties);
            }
          });
        };
        updateUserProfile();
      }}
    >
      {({
        values,
        errors,
        isValid,
        dirty,
        setFieldValue,
        setFieldTouched,
        setValues,
      }) => {
        submitData(isValid, dirty, values);
        return (
          <Form>
            <h6>Generator Details</h6>
            <Row className="mb-4">
              <div className="col-md-6">
                <label htmlFor="isCommissioned">Plant*</label>
                <div className="d-flex gap-3">
                  <div className="form-check-flex">
                    <Field
                      className="form-check-input"
                      type="radio"
                      name="isCommissioned"
                      value={1}
                      id="isCommissioned1"
                      onChange={() => {
                        setFieldValue("isCommissioned", 1);
                        setFieldValue("commissionedAt", "");
                      }}
                      checked={1 == values.isCommissioned}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="isCommissioned1"
                    >
                      Commissioned
                    </label>
                  </div>
                  <div className="form-check-flex">
                    <Field
                      className="form-check-input"
                      type="radio"
                      name="isCommissioned"
                      value={2}
                      id="isCommissioned2"
                      onChange={() => {
                        setFieldValue("isCommissioned", 2);
                        setFieldValue("commissionedAt", "");
                      }}
                      checked={2 == values.isCommissioned}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="isCommissioned2"
                    >
                      To Be Commissioned
                    </label>
                  </div>
                </div>
                <ErrorMessage
                  name="isCommissioned"
                  className="text-danger"
                  component="div"
                />
              </div>
              {values.isCommissioned && (
                <div className="col-md-6">
                  <label htmlFor="commissionedAt">Commissioned Date*</label>
                  <DatePicker
                    className="form-control custom-input w-100"
                    name="commissionedAt"
                    placeholderText="Select Date"
                    popperPlacement="bottom-start"
                    popperModifiers={{
                      flip: {
                        behavior: ["bottom"],
                      },
                      preventOverflow: {
                        enabled: false,
                      },
                    }}
                    // disabled={values.isCommissioned != 1}
                    selected={values.commissionedAt}
                    onChange={(e) => setFieldValue("commissionedAt", e)}
                    dateFormat={"dd-MMM-yyyy"}
                    onBlur={() => setFieldTouched("commissionedAt", true)}
                    minDate={values.isCommissioned == 2 && new Date()}
                    maxDate={values.isCommissioned == 1 && new Date()}
                    autoComplete="off"
                    showYearDropdown
                    showMonthDropdown
                    scrollableMonthYearDropdown
                  />
                  <ErrorMessage
                    className="text-danger"
                    name="commissionedAt"
                    component="div"
                  />
                </div>
              )}
            </Row>
            <Row className="mb-4">
              <div className="col-md-6">
                <div className="mb-3 fw-medium">
                  Generating Type{tab === "4" ? "" : "*"}
                </div>
                <div className="d-flex gap-3">
                  <div className="form-check-flex">
                    <Field
                      className="form-check-input"
                      type="radio"
                      name="generationType"
                      value={"RENEWABLE"}
                      id="generationType1"
                      checked={"RENEWABLE" == values.generationType}
                      onBlur={() => setFieldValue("energyTypeId", "")}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="generationType1"
                    >
                      Renewable
                    </label>
                  </div>
                  <div className="form-check-flex">
                    <Field
                      className="form-check-input"
                      type="radio"
                      name="generationType"
                      value={"NON_RENEWABLE"}
                      id="generationType2"
                      checked={"NON_RENEWABLE" == values.generationType}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="generationType2"
                    >
                      Non-Renewable
                    </label>
                  </div>
                </div>
                <ErrorMessage
                  name="generationType"
                  className="text-danger"
                  component="div"
                />
              </div>
              {values?.generationType && (
                <div className="col-md-6">
                  <label htmlFor="energyTypeId">
                    Energy Type{tab === "4" ? "" : "*"}
                  </label>
                  <Field
                    as="select"
                    name={"energyTypeId"}
                    className={`custom-input ${
                      values.energyTypeId ? "" : "custom-input-color"
                    } w-100`}
                    onChange={(e) => {
                      setFieldValue("energyTypeId", e.target.value);
                    }}
                  >
                    <option value="">Select Energy Type*</option>
                    {energyTypes
                      .filter((ite) => {
                        return values.generationType == "RENEWABLE"
                          ? ite.genType == "RENEWABLE"
                          : values.generationType == "NON_RENEWABLE"
                          ? ite.genType == "NON_RENEWABLE"
                          : "";
                      })
                      .map((item) => (
                        <option key={item?.id} value={item?.id}>
                          {item?.type}
                        </option>
                      ))}
                  </Field>
                  <ErrorMessage
                    name="energyTypeId"
                    className="text-danger"
                    component="div"
                  />
                </div>
              )}
            </Row>
            <Row className="justify-content-center align-items-center mb-4">
              <div className="col-md-6">
                <label htmlFor="plantSpecId">
                  Plant Specification{tab === "4" ? "" : "*"}
                </label>
                <Field
                  as="select"
                  disabled={tab == 4}
                  className={`custom-input ${
                    tab != 4 ? "" : "cursor-disabled"
                  } ${values.plantSpecId ? "" : "custom-input-color"} w-100`}
                  name={"plantSpecId"}
                  onChange={(e) => {
                    setFieldValue("plantSpecId", e.target.value);
                  }}
                >
                  <option value="">Select Plant Specification*</option>
                  {specificationTypes?.GENERATOR?.map((item) => (
                    <option key={item?.id} value={item?.id}>
                      {item?.name}
                    </option>
                  ))}
                </Field>
                <ErrorMessage
                  name="plantSpecId"
                  className="text-danger"
                  component="div"
                />
              </div>
              <div className="col-md-6">
                <label htmlFor="maximum-injection">
                  Maximum Injection Capacity (MW)*
                </label>
                <Field
                  className="form-control custom-input"
                  type="number"
                  onWheel={numberInputOnWheelPreventChange}
                  name="maxInjCap"
                />
                <ErrorMessage
                  name="maxInjCap"
                  className="text-danger"
                  component="div"
                />
              </div>
            </Row>
            <Row className="justify-content-center align-items-center mb-4">
              <div className="col-md-6">
                <label htmlFor="projectId">
                  Unique Project Identification Code
                </label>
                <Field
                  className="form-control custom-input"
                  type="text"
                  name="projectId"
                />
              </div>
              <div className="col-md-6">
                <label htmlFor="installedCap">
                  Installed Capacity (In MW){tab === "4" ? "" : "*"}
                </label>
                <Field
                  className="form-control custom-input"
                  type="number"
                  onWheel={numberInputOnWheelPreventChange}
                  name="installedCap"
                />
                <ErrorMessage
                  name="installedCap"
                  className="text-danger"
                  component="div"
                />
              </div>
            </Row>
            <Row className=" justify-content-center align-items-center mb-4">
              <div className="col-md-6">
                <div className="mb-3 fw-medium">Subsidy Received*</div>
                <div className="d-flex gap-3">
                  <div className="form-check-flex">
                    <Field
                      className="form-check-input"
                      type="radio"
                      name="isSubsidyRecvd"
                      value={1}
                      id="isSubsidyRecvd1"
                      checked={1 == values.isSubsidyRecvd}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="isSubsidyRecvd1"
                    >
                      Yes
                    </label>
                  </div>
                  <div className="form-check-flex">
                    <Field
                      className="form-check-input"
                      type="radio"
                      name="isSubsidyRecvd"
                      value={2}
                      id="isSubsidyRecvd2"
                      checked={2 == values.isSubsidyRecvd}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="isSubsidyRecvd2"
                    >
                      No
                    </label>
                  </div>
                </div>
                <ErrorMessage
                  name="isSubsidyRecvd"
                  className="text-danger"
                  component="div"
                />
              </div>
              <div className="col-md-6">
                <label htmlFor="subsidyType">Subsidy Type</label>
                <Field
                  className="form-control custom-input"
                  type="text"
                  name="subsidyType"
                />
                <ErrorMessage
                  name="subsidyType"
                  className="text-danger"
                  component="div"
                />
              </div>
            </Row>
            <Row className="mb-4">
              <div className="col-md-6">
                <div className="mb-3 fw-medium">ABT Metering Arrangement*</div>
                <div className="d-flex gap-3">
                  <div className="form-check-flex">
                    <Field
                      className="form-check-input"
                      type="radio"
                      name="isAbtExist"
                      value={1}
                      id="isAbtExist1"
                      checked={1 == values.isAbtExist}
                    />
                    <label className="form-check-label" htmlFor="isAbtExist1">
                      Exists
                    </label>
                  </div>
                  <div className="form-check-flex">
                    <Field
                      className="form-check-input"
                      type="radio"
                      name="isAbtExist"
                      value={2}
                      id="isAbtExist2"
                      checked={2 == values.isAbtExist}
                    />
                    <label className="form-check-label" htmlFor="isAbtExist2">
                      To Be Arranged
                    </label>
                  </div>
                </div>
                <ErrorMessage
                  name="isAbtExist"
                  className="text-danger"
                  component="div"
                />
              </div>
              <div className="col-md-6">
                <label htmlFor="controlAreaId">Control Area*</label>
                <Field
                  as="select"
                  className={`custom-input ${
                    values.controlAreaId ? "" : "custom-input-color"
                  } w-100`}
                  name={"controlAreaId"}
                  onChange={(e) => {
                    setFieldValue("controlAreaId", e.target.value);
                  }}
                >
                  <option value="">Select Control Area*</option>
                  {controlAreaTypes.map((item) => (
                    <option key={item?.id} value={item?.id}>
                      {item?.type}
                    </option>
                  ))}
                </Field>
                <ErrorMessage
                  name="controlAreaId"
                  className="text-danger"
                  component="div"
                />
              </div>
            </Row>
            <Row className="justify-content-center align-items-center mb-4">
              <div className="col-md-6">
                <div className="mb-3 fw-medium">Point of Injection (POI)*</div>
                <div className="d-flex gap-3">
                  {allPointDrawl.map((item, index) => (
                    <div className="form-check-flex">
                      <Field
                        className="form-check-input"
                        type="radio"
                        name="poiId"
                        value={item?.id}
                        id={`poiId${index + 1}`}
                        checked={item?.id == values.poiId}
                      />
                      <label
                        className="form-check-label"
                        htmlFor={`poiId${index + 1}`}
                      >
                        {item?.value}
                      </label>
                    </div>
                  ))}
                </div>
                <ErrorMessage
                  name="poiId"
                  className="text-danger"
                  component="div"
                />
              </div>
              <div className="col-md-6">
                <label htmlFor="poiLocation">Name of Location of POI*</label>
                <Field
                  className="form-control custom-input"
                  type="text"
                  name="poiLocation"
                />
                <ErrorMessage
                  name="poiLocation"
                  className="text-danger"
                  component="div"
                />
              </div>
            </Row>
            {tab != 4 && (
              <>
                <Row className="justify-content-center align-items-center mb-4">
                  <div className="col-md-6">
                    <label htmlFor="regionId">Region*</label>
                    <Field
                      as="select"
                      className={`custom-input ${
                        values.regionId ? "" : "custom-input-color"
                      } w-100`}
                      name={"regionId"}
                      onChange={(e) => {
                        setFieldValue("regionId", e.target.value);
                        getAllStateByRegionId(e.target.value, dispatch);
                      }}
                    >
                      <option value="">Select Region*</option>
                      {regionTypes.map((item) => (
                        <option key={item?.id} value={item?.id}>
                          {item?.name}
                        </option>
                      ))}
                    </Field>
                    <ErrorMessage
                      name="regionId"
                      className="text-danger"
                      component="div"
                    />
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="stateUtId">State*</label>
                    <Field
                      as="select"
                      className={`custom-input ${
                        values.stateUtId ? "" : "custom-input-color"
                      } w-100`}
                      name={"stateUtId"}
                      onChange={(e) => {
                        setFieldValue("stateUtId", e.target.value);
                        handleStateChange(e.target.value);
                      }}
                    >
                      <option value="">Select State*</option>
                      {stateOptions.map((item) => (
                        <option key={item?.id} value={item?.id}>
                          {item?.name}
                        </option>
                      ))}
                    </Field>
                    <ErrorMessage
                      name="stateUtId"
                      className="text-danger"
                      component="div"
                    />
                  </div>
                </Row>
                <Row>
                  <div className="col-md-6">
                    <label htmlFor="discomId">Name of Discom*</label>
                    <Field
                      as="select"
                      name={"discomId"}
                      className={`custom-input ${
                        values.discomId ? "" : "custom-input-color"
                      } w-100`}
                      onChange={(e) => {
                        setValues({
                          ...values,
                          filteredVoltageLevels: discomTypes?.find(
                            (item) => item.id == e.target.value
                          )?.voltageLevels,
                          discomId: e.target.value,
                          discomVoltageId: "",
                        });
                      }}
                    >
                      <option value="">Select Name of Discom*</option>
                      {discomOptions?.map((item) => (
                        <option key={item?.id} value={item?.id}>
                          {item?.acronym}
                        </option>
                      ))}
                    </Field>
                    <ErrorMessage
                      name="discomId"
                      className="text-danger"
                      component="div"
                    />
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="discomVoltageId">Voltage level*</label>
                    <Field
                      as="select"
                      className={`custom-input ${
                        values.discomVoltageId ? "" : "custom-input-color"
                      } w-100`}
                      name="discomVoltageId"
                      onChange={(e) =>
                        setFieldValue("discomVoltageId", e.target.value)
                      }
                    >
                      <option value="">Select Voltage level*</option>
                      {(values.filteredVoltageLevels || [])?.map(
                        (voltageItem, index) => (
                          <option key={index} value={voltageItem}>
                            {voltageItem}
                          </option>
                        )
                      )}
                    </Field>
                    <ErrorMessage
                      name="discomVoltageId"
                      className="text-danger"
                      component="div"
                    />
                  </div>
                </Row>
              </>
            )}
            <hr
              style={{
                width: "100%",
                margin: "20px auto",
                marginBottom: "20px",
              }}
            />
            {tab == 1 ? (
              <Row className="mb-3">
                <div className="text-center mt-4 fw-bold">
                  <Button
                    className="btn btn-lg btn-signup py-3 px-4"
                    type="submit"
                  >
                    Submit & Sign up
                  </Button>
                </div>
              </Row>
            ) : (
              //Consumer details
              <>
                <h6>Consumer Details</h6>
                <Row className="justify-content-center align-items-center mb-4">
                  <div className="col-md-6">
                    <label htmlFor="maxCapDrawl">
                      Maximum Capacity of Drawal{tab === "4" ? "" : "*"}
                    </label>
                    <Field
                      className="form-control custom-input"
                      type="number"
                      onWheel={numberInputOnWheelPreventChange}
                      name="maxCapDrawl"
                    />
                    <ErrorMessage
                      name="maxCapDrawl"
                      className="text-danger"
                      component="div"
                    />
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="podId">Point Of Drawal</label>
                    <Field
                      as="select"
                      className={`custom-input ${
                        values.podId ? "" : "custom-input-color"
                      } w-100`}
                      name="podId"
                      onChange={(e) => setFieldValue("podId", e.target.value)}
                    >
                      <option value=""> Select Point Of Drawal</option>
                      {allPointDrawl.map((item) => (
                        <option key={item?.id} value={item?.id}>
                          {item?.value}
                        </option>
                      ))}
                    </Field>
                  </div>
                </Row>
                <Row className=" mb-4">
                  <div className="col-md-6">
                    <label htmlFor="specId">Consumer Specification</label>
                    <Field
                      as="select"
                      disabled={tab == 4}
                      className={`custom-input ${
                        tab != 4 ? "" : "cursor-disabled"
                      } ${values.specId ? "" : "custom-input-color"} w-100`}
                      name="specId"
                      onChange={(e) => {
                        setFieldValue("specId", e.target.value);
                      }}
                    >
                      <option value="">Select Consumer Specification</option>
                      {specificationTypes?.CONSUMER?.map((item) => (
                        <option key={item?.id} value={item?.id}>
                          {item?.name}
                        </option>
                      ))}
                    </Field>
                  </div>
                  {tab != 4 && (
                    <div className="col-md-6">
                      <label htmlFor="discomRegionId">Region*</label>
                      <Field
                        as="select"
                        className={`custom-input ${
                          values.discomRegionId ? "" : "custom-input-color"
                        } w-100`}
                        name={"discomRegionId"}
                        onChange={(e) => {
                          setFieldValue("discomRegionId", e.target.value);
                          getAllStatesbyRegionIdforCon(
                            e.target.value,
                            dispatch
                          );
                        }}
                      >
                        <option value="">Select Region*</option>
                        {regionTypes.map((item) => (
                          <option key={item?.id} value={item?.id}>
                            {item?.name}
                          </option>
                        ))}
                      </Field>
                      <ErrorMessage
                        name="discomRegionId"
                        className="text-danger"
                        component="div"
                      />
                    </div>
                  )}
                </Row>
                {tab != 4 && (
                  <>
                    <Row className="justify-content-center align-items-center mb-4">
                      <div className="col-md-6">
                        <label htmlFor="discomStateUtId">State*</label>
                        <Field
                          as="select"
                          className={`custom-input ${
                            values.discomStateUtId ? "" : "custom-input-color"
                          } w-100`}
                          name={"discomStateUtId"}
                          onChange={(e) => {
                            setFieldValue("discomStateUtId", e.target.value);
                            handleStateChangeforCon(e.target.value);
                          }}
                        >
                          <option value="">Select State*</option>
                          {stateOptionsCon.map((item) => (
                            <option key={item?.id} value={item?.id}>
                              {item?.name}
                            </option>
                          ))}
                        </Field>
                        <ErrorMessage
                          name="discomStateUtId"
                          className="text-danger"
                          component="div"
                        />
                      </div>
                      <div className="col-md-6">
                        <label htmlFor="conDiscomId">Name of Discom*</label>
                        <Field
                          as="select"
                          name={"conDiscomId"}
                          className={`custom-input ${
                            values.conDiscomId ? "" : "custom-input-color"
                          } w-100`}
                          onChange={(e) => {
                            setValues({
                              ...values,
                              conFilteredVoltageLevels: discomTypes?.find(
                                (item) => item.id == e.target.value
                              )?.voltageLevels,
                              conDiscomId: e.target.value,
                              conDiscomVoltageId: "",
                            });
                          }}
                        >
                          <option value="">Select Name of Discom</option>
                          {discomOptionsCon?.map((item) => (
                            <option key={item?.id} value={item?.id}>
                              {item?.acronym}
                            </option>
                          ))}
                        </Field>
                        <ErrorMessage
                          name="conDiscomId"
                          className="text-danger"
                          component="div"
                        />
                      </div>
                    </Row>
                    <Row>
                      <div className="col-md-6">
                        <label htmlFor="conDiscomVoltageId">
                          Voltage level*
                        </label>
                        <Field
                          as="select"
                          className={`custom-input ${
                            values.conDiscomVoltageId
                              ? ""
                              : "custom-input-color"
                          } w-100`}
                          name="conDiscomVoltageId"
                          onChange={(e) =>
                            setFieldValue("conDiscomVoltageId", e.target.value)
                          }
                        >
                          <option value="">Select Voltage level</option>
                          {(values.conFilteredVoltageLevels || [])?.map(
                            (voltageItem, index) => (
                              <option key={index} value={voltageItem}>
                                {voltageItem}
                              </option>
                            )
                          )}
                        </Field>
                        <ErrorMessage
                          name="conDiscomVoltageId"
                          className="text-danger"
                          component="div"
                        />
                      </div>
                    </Row>
                    <hr
                      style={{
                        width: "100%",
                        margin: "20px auto",
                        marginBottom: "20px",
                      }}
                    />
                  </>
                )}
                <Row className="mb-3">
                  <div className="text-center mt-4 fw-bold">
                    <Button
                      className="btn btn-lg btn-signup py-3 px-4"
                      type="submit"
                    >
                      Submit & Sign up
                    </Button>
                  </div>
                </Row>
              </>
            )}
          </Form>
        );
      }}
    </Formik>
  );
};

export default React.memo(EditPlantDetails);
